<div
  class="modal-container"
  role="dialog"
  aria-modal="true"
  aria-labelledby="modal-title"
  aria-describedby="modal-subtitle"
  #modalRoot
>
  <div class="modal-body">
    <div class="modal-body__text">
      <span class="modal-body__text--title text--bold text--18">{{ 'ERROR_CLIENT.MODAL.TITLE' | translate }}</span>
      <span
        class="modal-body__text--description text--16 text--decorator"
        [innerHTML]="'ERROR_CLIENT.MODAL.DESCRIPTION' | translate"
      ></span>
    </div>
    <qb-ita-button
      #callButton
      tabindex="0"
      buttonPosition="center"
      type="button"
      color="primary"
      size="large"
      [label]="'ERROR_CLIENT.MODAL.BUTTON' | translate"
      (btnClick)="goData()"
    ></qb-ita-button>

    <div class="modal-icon-close" tabindex="0" (keydown)="onClose()">
      <ion-icon #closeButton class="verti-close-16" role="button" aria-label="Close" (click)="onClose()"></ion-icon>
    </div>
  </div>
</div>
